import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from '../component/layouts/dashboard/dashboard.component';
import { AuthGuard } from '../shared/auth.guard';
import { PermissionGuard } from '../shared/permission.guard';
import { MaintenanceListComponent } from './maintenance-list/maintenance-list.component';
import { MaintenanceAddComponent } from './maintenance-add/maintenance-add.component';
import { MaintenanceSupplierComponent } from './maintenance-supplier/maintenance-supplier.component';
import { MaintenanceSupplierComparisonComponent } from './maintenance-supplier-comparison/maintenance-supplier-comparison.component';
import { AddItemComponent } from './add-item/add-item.component';
import { MaintenanceUpdateComponent } from './maintenance-update/maintenance-update.component';
import { MaintenanceViewComponent } from './maintenance-view/maintenance-view.component';

const routes: Routes = [{
    path: "maintenance", component: DashboardComponent, canActivate: [AuthGuard, PermissionGuard], children: [{
        path: "list", component: MaintenanceListComponent, data: { module: "Mantenimiento de unidades", accion: "Listado de Unidades", type: "list" }
    }, {
        path: "add", component: MaintenanceAddComponent, data: { module: "Mantenimiento de unidades", accion: "Solicitud de mantenimiento", type: "add" }
    }, {
        path: "supplier/add", component: MaintenanceSupplierComponent, data: {module: "Mantenimiento de unidades", accion: "Registro de proveedores", type: "supplier"}
    }, {
        path: "repair/add", component: MaintenanceSupplierComponent, data: {module: "Mantenimiento de unidades", accion: "Registro de refaccionarias o tiendas", type: "supplier"}
    }, {
        path: "supplier/comparison", component: MaintenanceSupplierComparisonComponent, data: {module: "Mantenimiento de unidades", accion: "Comparativos de proveedores", type: "supplier"}
    }, {
        path: "coordinator/add", component: AddItemComponent, data: {module: "Mantenimiento de unidades", accion: "Solicitud de mantenimiento", type: "supplier"}
    }, {
        path: "update", component: MaintenanceUpdateComponent, data: {module: "Mantenimiento de unidades", accion: "Solicitud de mantenimiento", type: "supplier"}
    }, {
        path: "view/:id", component: MaintenanceViewComponent, data: {module: "Mantenimiento de unidades", accion: "Listado de pago / Solicitud de pago", type: "supplier"}
    }]
}];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MaintenanceRoutingModule { }
